angular.module('impactx.account').filter('ibanFilter', function() {
    /**
     * Formats an string to have spaces every n characters.
     *
     * @param  {string} text The String to format.
     * @return {string} The formatted String.
     */
    return function(text) {
        var inputIdx=0, charToInspect, resultIdx = 0, formatted = '', pattern = /[A-Za-z0-9]+/i;

        /**
         * Checks if the character is valid. (Currently position is not tested, i.e. you could have many letter in your IBAN)
         * (It's not part to validate it here, just to print it out)
         * @param char character to test
         * @param idx
         * @returns {boolean} true when character is 'allowed'
         */
        function isValidIBANCharacter(char, idx) {
            return pattern.test(char);
        }

        text = text || '';

        text = text.toUpperCase();

        text = text.trim();

        text = text.replace(/ /g, '');

        if(text != '') {

            for(inputIdx = 0; inputIdx < text.length; inputIdx++) {
                charToInspect = text[inputIdx];

                if(isValidIBANCharacter(charToInspect, resultIdx)) {
                    if(resultIdx > 0 && resultIdx % 4 == 0) {
                        formatted += ' ';
                    }
                    formatted += charToInspect;

                    resultIdx++;
                }
            }
        }

        return formatted;
    };
});
